export default __webpack_public_path__ + "static/media/in.0252e64d.svg";